<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="goBack()">
        <ion-icon name="arrow-back" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Recommendation Details</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <ion-spinner></ion-spinner>
    <p>Loading recommendation...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !isLoading" class="error-container">
    <ion-card color="danger">
      <ion-card-content>
        <p>{{ error }}</p>
        <ion-button fill="outline" (click)="loadRecommendation()" color="light">
          Try Again
        </ion-button>
      </ion-card-content>
    </ion-card>
  </div>

  <!-- Recommendation Details -->
  <div
    *ngIf="recommendation && !isLoading && !error"
    class="recommendation-details"
  >
    <!-- Header Card -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>{{ recommendation.category }}</ion-card-title>
        <ion-card-subtitle>
          <ion-chip
            [color]="
              getRecommendationTypeColor(recommendation.recommendationType)
            "
            size="small"
          >
            <ion-icon
              [name]="
                getRecommendationTypeIcon(recommendation.recommendationType)
              "
              size="small"
            ></ion-icon>
            {{
              recommendation.recommendationType === "create"
                ? "Create New Article"
                : "Update Existing Article"
            }}
          </ion-chip>
          <ion-chip
            *ngIf="recommendation.ignoredAt"
            color="medium"
            size="small"
            outline
          >
            <ion-icon name="eye-off" size="small"></ion-icon>
            Ignored
          </ion-chip>
        </ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <div *ngIf="recommendation.existingArticleTitle">
          <h4>Existing Article</h4>
          <p>{{ recommendation.existingArticleTitle }}</p>
        </div>

        <div class="stats-section">
          <h4>Statistics</h4>
          <div class="stats-grid">
            <div class="stat-item">
              <h3>{{ getUniqueConversationCount() }}</h3>
              <p>Conversations</p>
            </div>
            <div class="stat-item">
              <h3>{{ recommendation.insights.length }}</h3>
              <p>Insights</p>
            </div>
            <div class="stat-item">
              <h3>{{ recommendation.topics?.length || 0 }}</h3>
              <p>Topics</p>
            </div>
          </div>
        </div>

        <div class="metadata-section">
          <ion-text color="medium">
            <small>
              Created {{ formatDateTime(recommendation.createdAt) }}
              <span *ngIf="recommendation.ignoredAt">
                • Ignored {{ formatDateTime(recommendation.ignoredAt) }}
              </span>
            </small>
          </ion-text>
        </div>
      </ion-card-content>
    </ion-card>

    <!-- Related Insights -->
    <ion-card *ngIf="recommendation.insights.length > 0">
      <ion-card-header>
        <ion-card-title
          >Related Insights ({{
            recommendation.insights.length
          }})</ion-card-title
        >
      </ion-card-header>
      <ion-card-content>
        <ion-list>
          <a
            *ngFor="let insight of recommendation.insights"
            [routerLink]="getInsightUrl(insight.id)"
          >
            <ion-item>
              <ion-label>
                <h3>{{ insight.category }} ({{ insight.language }})</h3>
                <p>
                  {{ insight.topicCount }} topics,
                  {{ insight.conversationCount }} conversations
                </p>
                <ion-text color="medium">
                  <small>Created {{ formatDate(insight.createdAt) }}</small>
                </ion-text>
              </ion-label>
              <ion-icon name="chevron-forward" slot="end"></ion-icon>
            </ion-item>
          </a>
        </ion-list>
      </ion-card-content>
    </ion-card>

    <!-- Topics -->
    <ion-card *ngIf="recommendation.topics && recommendation.topics.length > 0">
      <ion-card-header>
        <ion-card-title
          >Topics ({{ recommendation.topics.length }})</ion-card-title
        >
      </ion-card-header>
      <ion-card-content>
        <ion-list>
          <a
            *ngFor="let topic of recommendation.topics"
            [routerLink]="getTopicUrl(topic.id)"
          >
            <ion-item>
              <ion-label>
                <h3>{{ topic.topicTitle }}</h3>
                <p>{{ topic.topicDescription }}</p>
                <div style="margin-top: 0.5rem">
                  <ion-text [color]="getConfidenceColor(topic.confidence)">
                    <small
                      >{{ topic.confidence * 100 | number: "1.0-0" }}%
                      confidence</small
                    >
                  </ion-text>
                  <span> • </span>
                  <ion-text color="medium">
                    <small>{{ formatDate(topic.createdAt) }}</small>
                  </ion-text>
                </div>
              </ion-label>
              <ion-icon name="chevron-forward" slot="end"></ion-icon>
            </ion-item>
          </a>
        </ion-list>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
